import * as React from "react";
import type { SVGProps } from "react";
const SvgImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#image_svg__a)">
      <path d="M16 18c-.26 0-.51-.1-.71-.29l-5-5c-.53-.51-1.05-.51-1.6.01l-4.98 4.99A.996.996 0 1 1 2.3 16.3l5-5c1.32-1.28 3.09-1.28 4.4-.01l5.01 5.01A.996.996 0 0 1 16 18" />
      <path d="M21 18c-.26 0-.51-.1-.71-.29l-3-3c-.53-.51-1.05-.51-1.6.01l-.99.99a.996.996 0 1 1-1.41-1.41l1-1c1.33-1.28 3.09-1.28 4.4-.01l3.01 3.01a.996.996 0 0 1-.71 1.7zM16 11c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
      <path d="M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4M6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z" />
    </g>
    <defs>
      <clipPath id="image_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgImage;
